module.exports = __webpack_public_path__ + "img/258.835e7d68.png";